import script from "./StoreManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreManagement.vue?vue&type=script&setup=true&lang=js"

import "./StoreManagement.vue?vue&type=style&index=0&id=15d08778&lang=css"

const __exports__ = script;

export default __exports__